import styled from 'styled-components';

export const DatiList = styled.div.withConfig({ displayName: '-DatiList' })`
	overflow: hidden;
	background-color: #ffffff;
	flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
	height: calc(100% - 137px);
`;
